<template>
  <b-row>
    <b-col lg="4">
      <statistic-card-horizontal statisticTitle="المستخدمين المتواجدين اونلاين" :statistic="users" icon="UsersIcon"
        color="info" />
    </b-col>
    <b-col lg="4">
      <statistic-card-horizontal :statisticTitle="$t('online_session.online_session_now')" :statistic="online"
        icon="VideoIcon" />
    </b-col>
    <b-col lg="4">
      <statistic-card-horizontal statisticTitle="المتقدمين للدراسة في جميع المراحل"
        :statistic="statisticsData.applicants_for_study == 0 ? '..' : statisticsData.applicants_for_study"
        icon="FileTextIcon" />
    </b-col>
    <b-col lg="4">
      <statistic-card-horizontal statisticTitle="المؤهلين للدراسة والذين استكملوا متطلبات الدراسة"
        :statistic="statisticsData.eligible_to_study == 0 ? '..' : statisticsData.eligible_to_study"
        icon="CheckCircleIcon" />
    </b-col>
    <b-col lg="4">
      <statistic-card-horizontal statisticTitle="عدد الفصول الافتراضية"
        :statistic="statisticsData.virtual_classes == 0 ? '..' : statisticsData.virtual_classes"
        icon="VideoIcon" />
    </b-col>
    <b-col lg="4">
      <statistic-card-horizontal statisticTitle="عدد الواجبات التي تم انجازها"
        :statistic="statisticsData.activity_answers == 0 ? '..' : statisticsData.activity_answers"
        icon="CheckCircleIcon" />
    </b-col>
    <b-col lg="4">
      <statistic-card-horizontal statisticTitle="عدد المواسم التعليمية"
        :statistic="statisticsData.edu_seasons == 0 ? '..' : statisticsData.edu_seasons" icon="CalendarIcon" />
    </b-col>
    <b-col lg="4">
      <statistic-card-horizontal statisticTitle="عدد المقررات  الدراسية"
        :statistic="statisticsData.edu_courses == 0 ? '..' : statisticsData.edu_courses" icon="BookIcon" />
    </b-col>
    <b-col lg="4">
      <statistic-card-horizontal statisticTitle="عدد اللقاءات المسجلة"
        :statistic="statisticsData.OnlineSession == 0 ? '..' : statisticsData.OnlineSession" icon="PlayCircleIcon" />
    </b-col>
    <b-col lg="12" v-if="statisticsData.male_students == 0">
      <h4>يتم تجهيز الإحصائيات ...</h4>
    </b-col>
    <b-col lg="12">
      <CountriesChart :countries="statisticsData.countries" v-if="statisticsData.countries.length > 0" />
    </b-col>
    <b-col lg="6">
      <StudentsGenderChart v-if="statisticsData.male_students > 0"
        :gendersData="{ male: statisticsData.male_students, female: statisticsData.female_students }" />
    </b-col>
    <b-col lg="6">
      <StudentsUndergraduateLevelChart v-if="statisticsData.undergraduate > 0"
        :undergraduateData="{ undergraduate: statisticsData.undergraduate, graduate: statisticsData.graduate }" />
    </b-col>
    <b-col lg="6">
      <QuranProgramsChart v-if="statisticsData.active > 0"
        :quranProgramData="{ active: statisticsData.active, inactive: statisticsData.inactive }" />
    </b-col>
  </b-row>
</template>

<script>
import StatisticCardVertical from "./components/StatisticCardVertical.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import UsersController from "@/Controllers/UsersController";
import OnlineSessionController from "@/Controllers/OnlineSessionController";
import CountriesChart from "./components/CountriesChart.vue";
import StudentsGenderChart from "./components/StudentsGenderChart.vue";
import StudentsUndergraduateLevelChart from "./components/StudentsUndergraduateLevelChart.vue";
import QuranProgramsChart from "./components/QuranProgramsChart.vue";

export default {
  components: {
    StatisticCardVertical,
    StatisticCardHorizontal,
    CountriesChart,
    StudentsGenderChart,
    StudentsUndergraduateLevelChart,
    QuranProgramsChart
  },
  data() {
    return {
      // Area charts
      subscribersGained: {},
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},

      // Line Charts
      siteTraffic: {},
      activeUsers: {},
      newsletter: {},
      users: 0,
      online: 0,
      statisticsData: {
        applicants_for_study: 0,
        eligible_to_study: 0,
        accepted_students: 0,
        male_students: 0,
        female_students: 0,
        undergraduate: 0,
        edu_seasons: 0,
        activity_answers: 0,
        virtual_classes: 0,
        edu_courses: 0,
        graduate: 0,
        countries: [],
        active : 0,
        inactive : 0,
        OnlineSession : 0
      },

    };
  },
  async created() {
    this.users = await new UsersController().getAllOnline({ count: 1 });
    new OnlineSessionController()
      .GetAll({
        count: 1,
        now: true,
      })
      .then((res) => {
        this.online = res;
      });
    let res = await new UsersController().getStatistics();
    this.statisticsData = {
      applicants_for_study: res.applicants_for_study,
      eligible_to_study: res.eligible_to_study,
      accepted_students: res.accepted_students,
      male_students: res.male_students,
      female_students: res.female_students,
      undergraduate: res.students_waiting_approval,
      graduate: res.total_students - res.students_waiting_approval,
      countries: res.countries,
      edu_seasons: res.edu_seasons,
      activity_answers: res.activity_answers,
      virtual_classes: res.virtual_classes,
      edu_courses: res.edu_courses,
      active: res.quran_programs.active,
      inactive : res.quran_programs.inactive,
      OnlineSession : res.OnlineSession
    }

  },
};
</script>

<style></style>